export default __webpack_public_path__ + "static/media/user.e49cae09.gif";